// extracted by mini-css-extract-plugin
export default {"v-asphalt":"var(--asphalt)","icon":"decimal_input__icon__g3Xin"};